import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ReferenceSquare = ({ status, approver }) => (
  <Row className="my-3">
    <Col sm={2}>
      <div
        style={{
          alignItems: 'center',
          background: approver ? status.bgColor : status.color,
          border: '1px solid #ccc',
          display: 'flex',
          justifyContent: 'center',
          height: '40px',
          width: '40px'
        }}
      >
        {approver ? <span style={{ color: status.textColor }}>1</span> : ''}
      </div>
    </Col>
    <Col>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          height: '40px'
        }}
      >
        <span style={{ fontWeight: 700 }}>
          {status.descripcion === '-' ? 'Sin aprobación' : status.descripcion}
        </span>
      </div>
    </Col>
  </Row>
);

export default ReferenceSquare;

ReferenceSquare.propTypes = {
  approver: PropTypes.bool,
  status: PropTypes.shape({
    id: PropTypes.number,
    descripcion: PropTypes.string,
    color: PropTypes.string,
    bgColor: PropTypes.string,
    textColor: PropTypes.string
  })
};

ReferenceSquare.defaultProps = {
  approver: false,
  status: null
};
